import { render, staticRenderFns } from "./SoftwareActions.vue?vue&type=template&id=56579497&"
import script from "./SoftwareActions.vue?vue&type=script&lang=js&"
export * from "./SoftwareActions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports